import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDistribucionTalentosService } from "../../../../services/dashboard/distribucionTalentos/distribucionTalentos.services";

export const getDistribucionTalentosThunk = createAsyncThunk(
  "distribucionTalentos/getDistribucion",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { escuela, plantel } = getState().dashboardFilters;
      return await getDistribucionTalentosService({ escuela, plantel });
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error obteniendo distribución de talentos"
      );
    }
  }
);
